import React from 'react'
import { MdArrowBack } from 'react-icons/md'
import { useNavigate } from 'react-router-dom'
import { FiRefreshCcw } from "react-icons/fi";

export default function Card({ isBorder = false, bgColor = "bg-white", borderColor = "border-brand-400", title, subTitle, children, isBack = false, isRefresh = false, doRefresh }) {
    const navigate = useNavigate()

    return (
        <div className={
            "rounded-2xl shadow-card transition-shadow hover:shadow-pop p-4 sm:p-5 animate-fade-up "
            + (isBorder ? " border-t-4 " + borderColor : " border border-gray-100")
            + " " + bgColor
        }>
            {(title || isBack || isRefresh) &&
                <div className="flex items-center gap-1 mb-3">
                    {isBack &&
                        <button title='Back' className='mr-1 grid place-items-center h-8 w-8 rounded-lg text-gray-600 hover:bg-gray-100 active:bg-gray-200 transition' onClick={() => navigate(-1)}>
                            <MdArrowBack />
                        </button>
                    }
                    {title && <h1 className='flex-1 font-display text-lg sm:text-xl font-bold text-gray-900 leading-7'>{title}</h1>}
                    {isRefresh &&
                        <button title='Refresh' className='grid place-items-center h-8 w-8 rounded-lg text-brand-500 hover:bg-brand-50 active:bg-brand-100 transition' onClick={doRefresh}>
                            <FiRefreshCcw />
                        </button>
                    }
                </div>
            }
            {subTitle && <h3 className="-mt-2 mb-3 text-sm text-gray-500">{subTitle}</h3>}
            {children}
        </div>
    )
}
